module.exports = __webpack_public_path__ + "static/media/img01.b51c55a5.JPG";